export default __webpack_public_path__ + "static/media/vhions logo.0e7d037d.png";